export const invoiceDynamicColumns = [
  { 
    name: 'Batch Name', 
    visible: false
  },
  { 
    name: 'Business Unit', 
    visible: false
  },
  { 
    name: 'Company', 
    visible: false
  },
  { 
    name: 'Document Number', 
    visible: false
  },
  { 
    name: 'Fiscal Date', 
    visible: false
  },
  { 
    name: 'Import Profile', 
    visible: false
  },
  { 
    name: 'Vendor Number', 
    visible: false
  }
];


// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceColumnsSlidingPanel/InvoiceDynamicColumns.js